import React, { useEffect, useRef } from "react";
import { collection, query, where, onSnapshot, orderBy, limit } from "firebase/firestore";
import { db } from "../util/firebase";
import { useToast } from "./ui";

const playBeep = () => {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(880, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(440, ctx.currentTime + 0.25);
    gain.gain.setValueAtTime(0.2, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.25);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + 0.25);
  } catch {
    // Ignore audio errors if browser blocks autoplay
  }
};

export const GlobalAdminAlerts = ({ profileState }) => {
  const { toast } = useToast();
  const isFirstLoadRef = useRef(true);
  const unsubRef = useRef(null);

  useEffect(() => {
    if (!profileState || !db) return;

    try {
      const q = query(
        collection(db, "AdminAlerts"),
        where("status", "==", "unread"),
        orderBy("createdAt", "desc"),
        limit(10)
      );

      unsubRef.current = onSnapshot(
        q,
        (snapshot) => {
          if (isFirstLoadRef.current) {
            isFirstLoadRef.current = false;
            return;
          }

          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              const alert = change.doc.data();
              const isDanger = alert.level === "danger" || alert.type === "DUPLICATE_SLIP";
              const isWarning = alert.level === "warning" || alert.type === "NO_SLIP_ID";

              if (isDanger) {
                playBeep();
              }

              toast({
                className: isDanger
                  ? "bg-[#c15b78] text-white"
                  : isWarning
                  ? "bg-[#FAB12F] text-white"
                  : "bg-[#4DA1A9] text-white",
                title: alert.title || "แจ้งเตือนระบบ",
                description: alert.message || `คำสั่งซื้อ #${alert.shortId || ""}`,
              });
            }
          });
        },
        (err) => {
          console.warn("GlobalAdminAlerts listener warning:", err?.message);
        }
      );
    } catch (e) {
      console.warn("Failed to initialize GlobalAdminAlerts:", e);
    }

    return () => {
      if (unsubRef.current) unsubRef.current();
    };
  }, [profileState, toast]);

  return null;
};

export default GlobalAdminAlerts;
